module.exports = __webpack_public_path__ + "static/media/fn-logo-red-green.88f51957.png";